import { t } from 'ember-intl';
import type { TOC } from '@ember/component/template-only';
import LoanDetail from './linked-loans-summary/loan-detail';
import screenIs from 'tio-common/helpers/screen-is';
import type { LoanSummary } from 'tio-common/types/loan-summary';
import type { AccountExtension as AccountModel } from 'tio-data/data/resources/account.ext';
import type { PersonExtension as PersonModel } from 'tio-data/data/resources/person.ext';
import { Section, VStack } from 'tio-ui/components/layout';
import Table from 'tio-ui/components/table';
import type { ObservableSource } from 'tio-employee/services/observability';

export interface AccountsLinkedLoansSummarySignature {
  Args: {
    accounts: AccountModel[];
    person: PersonModel;
    loanSummary: LoanSummary;
    source: ObservableSource;
  };
}

const AccountsLinkedLoansSummary: TOC<AccountsLinkedLoansSummarySignature> = <template>
  <VStack>
    {{#if (screenIs "md")}}
      {{#each @accounts as |account|}}
        <Section class="overflow-auto">
          <:header>{{account.institutionName}}</:header>
          <:body>
            <Table>
              <:thead as |options|>
                <options.tr>
                  <options.th>
                    {{t "pslf_dashboard.actions.dialog.loan_name"}}
                  </options.th>
                  <options.th>
                    {{t "pslf_dashboard.actions.dialog.repayment_plan"}}
                  </options.th>
                  <options.th>
                    {{t "pslf_dashboard.actions.dialog.loan_type"}}
                  </options.th>
                  <options.th>
                    {{t "pslf_dashboard.actions.dialog.interest_rate"}}
                  </options.th>
                  <options.th class="text-right">
                    {{t "pslf_dashboard.actions.dialog.current_balance"}}
                  </options.th>
                </options.tr>
              </:thead>
              <:tbody as |options|>
                {{#each account.activeLoans as |loan|}}
                  <LoanDetail
                    @style="row"
                    @loan={{loan}}
                    @options={{options}}
                    @source={{@source}}
                  />
                {{/each}}
              </:tbody>
            </Table>
          </:body>
        </Section>
      {{/each}}
    {{else}}
      {{#each @accounts as |account|}}
        <Section>
          <:header>{{account.institutionName}}</:header>
          <:body>
            <ul>
              {{#each account.activeLoans as |loan|}}
                <LoanDetail @style="list" @loan={{loan}} @source={{@source}} />
              {{/each}}
            </ul>
          </:body>
        </Section>
      {{/each}}
    {{/if}}
  </VStack>
</template>;

export default AccountsLinkedLoansSummary;
